// extracted by mini-css-extract-plugin
module.exports = {"arrows":"x_bM","arrows__right":"x_bN","arrows__left":"x_bP"};